import Box from '@mui/material/Box'
import React from 'react'
import HalfSizeBanner from '../components/Banners/HalfSizeBanner'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import DoubleAccordion from '../components/Accordions/DoubleAccordion'
import TextBtnSection from '../components/Section/TextBtnSection'
import ContentCard from '../components/Cards/ContentCard'
import { useTranslation } from '../hook/Translation'

export default function TheDeepRewire() {
    const { t } = useTranslation();
  const accodirons = [
        {
            title: 'What it is?',
            content: 'This ritual begins with a calming foot soak infused with Himalayan salts and essential oils to ground you. Once on the massage table, you’ll experience a blend of massage techniques drawn from around the world: rhythmic Balinese-style strokes to ease muscle tension, gentle Hawaiian Lomi-Lomi waves for deep relaxation, and maybe some Thai stretching for energy flow. Warm aromatherapy oils a signature blend exclusive to RINU, perhaps with notes of frankincense, lavender, and citrus are used generously, cocooning your skin in moisture and your senses in a subtle fragrance. Hot stones may be placed on key points along your spine and chakra areas, their soothing heat penetrating deeply to melt away knots. Throughout,',
            content2: 'your therapist tunes the pressure to your preference, ensuring therapeutic relief (knots worked out from head, neck, shoulders) while never disrupting the meditative tranquility. The RINU Ritual often includes a brief scalp massage and foot reflexology segment, truly covering you from crown to toe. A soft chime or Tibetan singing bowl might gently ring at the conclusion, bringing you back to awareness.'
        },
        {
            title: 'How it works',
            content: 'Precise ablation at the surface plus controlled dermal heat stimulates collagen remodeling and new skin formation',
            content2: 'your therapist tunes the pressure to your preference, ensuring therapeutic relief (knots worked out from head, neck, shoulders) while never disrupting the meditative tranquility. The RINU Ritual often includes a brief scalp massage and foot reflexology segment, truly covering you from crown to toe. A soft chime or Tibetan singing bowl might gently ring at the conclusion, bringing you back to awareness.'
        },
    ]

    return (
        <Box pb={'50px'}>

            <Box>
                <HalfSizeBanner>
                    <Box height={'100%'} bgcolor={'text.secondary'}>
                        <Box component={'img'} alt={'Neuromuscular'}src={`${process.env.REACT_APP_SITE_URL}/images/2026/05/img_69f85924584b78.97179651.jpg`} loading='lazy' width={1} height={1} className='fitCover'  />
                    </Box>
                </HalfSizeBanner>
            </Box>
            <Box className="generalContainer" marginX={'auto'} marginTop={{md: '80px', xs: '50px'}}>
                <TextBtnSection
                    titleSize={{ md: 6, xs: 12 }}
                    data={{
                       type: t('bodyherapies'),
                        title: t('the_deep_rewire.mainTitle'),
                        description: t('the_deep_rewire.mainDesc'),
                        bookUrl: `https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të rezervoj seancën e Aroma Therapy")}`,
                        learn: "",
                        price: `${t('price_session')} €60 - 60min`

                    }}
                />
            </Box>

            {/* <Grid container gap={{md: '80px', xs: '50px'}} className='generalContainer' sx={{ marginX: 'auto' }} marginTop={{md: '114px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={600} textAlign={'center'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <DoubleAccordion data={accodirons} />
                </Grid>
            </Grid>

             <Grid container className='generalContainer' sx={{ marginX: 'auto' }} gap={'22px'} marginTop={{md: '120px', xs: '50px'}} mb={{md: '149px', xs: '50px'}}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{md: '1.125rem', xs: '1rem'}}>
                        Areas
                    </Typography>
                </Grid>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" className='dColor' fontWeight={'bold'} fontSize={{md: '30px', xs: '1.125rem'}}>
                        Focus is on your problem areas that could be the neck/jaw (for TMJ or tech-neck issues), shoulders, upper back, lower back/hips (we do a lot of glute work if sciatica or hip tightness), or even forearms/hands (for carpal tunnel syndrome relief). We also address the interconnected areas; e.g., for lower back issues we’ll likely work on hips, glutes, even quads, since everything is connected.
                    </Typography>
                </Grid>
            </Grid> */}
        </Box>
    )
}